import {
  ColumnFilter,
  ColumnFiltersState,
  flexRender,
  Header,
  Updater,
} from "@tanstack/react-table";
import clsx from "clsx";
import { ArrowDown } from "lucide-react";
import { FullFilter, SimpleFilterInput } from "./tableFilter";

export default function TableHeader<RowType>(
  props: Header<RowType, any> & {
    filterState: ColumnFilter | undefined;
    fullFilters: boolean;
    setFilters: (updater: Updater<ColumnFiltersState>) => void;
  },
) {
  const {
    id,
    colSpan,
    isPlaceholder,
    fullFilters,
    filterState,
    column: {
      columnDef: { header, meta: { filterVariant } = {} },
      getCanSort,
      getCanFilter,
      getIsFiltered,
      getIsSorted,
      getToggleSortingHandler,
      getFilterValue,
      setFilterValue,
    },
    getContext,
    setFilters,
  } = props;

  if (isPlaceholder) return null;

  return (
    <th
      colSpan={colSpan}
      className={clsx("text-start group", {
        "px-3.5 py-2.5": getContext().table.options.meta?.size === "lg",
        "px-2 py-1.5": getContext().table.options.meta?.size === "sm",
        "border border-gunmetal-100": getContext().table.options.meta?.bordered,
      })}
    >
      <div className={"flex justify-between align-middle"}>
        <div className="flex-1 flex gap-1">
          <div
            className={clsx({
              "cursor-pointer select-none": getCanSort(),
              "text-primary": getIsSorted(),
            })}
            onClick={getToggleSortingHandler()}
          >
            {flexRender(header, getContext())}
            {getCanSort() && getIsSorted() && (
              <ArrowDown
                size="16"
                className={clsx("transition-transform duration-300", {
                  "rotate-180": getIsSorted() === "desc",
                })}
              />
            )}
          </div>
          {fullFilters && getCanFilter() && (
            <FullFilter
              id={id}
              filterVariant={filterVariant ?? { type: "text" }}
              filterState={filterState}
              setFilters={setFilters}
              alwaysDisplay={getIsFiltered()}
            />
          )}
        </div>
      </div>
      {!fullFilters && getCanFilter() && (
        <SimpleFilterInput
          onChange={setFilterValue}
          initValue={(getFilterValue() as string) || ""}
        />
      )}
    </th>
  );
}
